module.exports = __webpack_public_path__ + "static/media/positive_event_response.94cab6f4.png";